import { all, call, put, takeLatest } from 'redux-saga/effects';

import { actions } from 'react/api/actions/wglnIntegrationLogs';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

const {
  fetchLogs,
  updateLogs,
  setIsLoadingLogs,
  clearLogs
} = actions;

function showLoading() {
  App.Forms.WGLNIntegrationLog?.filterBuilder?.loading?.init();
  App.Forms.WGLNIntegrationLog?.filterBuilder?.loading?.show();
}

function hideLoading() {
  App.Forms.WGLNIntegrationLog?.filterBuilder?.loading?.hide();
}

function* clearLogsData() {
  yield put({
    type: clearLogs
  });
}

function* updateLogsData(data, shouldClearBeforeUpdateLogs) {
  yield put({
    type: updateLogs,
    payload: {
      data,
      shouldClearBeforeUpdateLogs
    }
  });
}

function* fetchLogsSaga(action) {
  const { filtersPayload } = action.payload;

  const encodedURL = encodeURI('/WglnLogsIntegration');
  const requestBody = Object.assign({
    page: 0,
    pageSize: 51,
  }, filtersPayload);

  yield all([
    put({
      type: setIsLoadingLogs,
      payload: {
        isLoading: true
      }
    }),
    call(showLoading)
  ]);

  const wlgnIntegrationLogs = yield call(defaultFetch, encodedURL, requestBody, 'POST');

  if (!wlgnIntegrationLogs?.error) {
    const shouldClearData = requestBody.page === 0 && !wlgnIntegrationLogs.length;
    const shouldClearBeforeUpdateLogs = requestBody.page === 0 && wlgnIntegrationLogs.length;

    if (shouldClearData) {
      yield clearLogsData();
    } else {
      yield updateLogsData(wlgnIntegrationLogs, shouldClearBeforeUpdateLogs);
    }
  }

  yield all([
    put({
      type: setIsLoadingLogs,
      payload: {
        isLoading: false
      }
    }),
    call(hideLoading)
  ]);
}

function* watchFetchLogs() {
  yield takeLatest(fetchLogs, fetchLogsSaga);
}

export default function* () {
  yield all([
    watchFetchLogs(),
  ]);
}
